import { render, staticRenderFns } from "./PackageUpgradeVirtualModal.vue?vue&type=template&id=0efadbca&scoped=true"
import script from "./PackageUpgradeVirtualModal.vue?vue&type=script&lang=ts"
export * from "./PackageUpgradeVirtualModal.vue?vue&type=script&lang=ts"
import style0 from "./PackageUpgradeVirtualModal.vue?vue&type=style&index=0&id=0efadbca&prod&scoped=true&lang=css"
import style1 from "./PackageUpgradeVirtualModal.vue?vue&type=style&index=1&id=0efadbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efadbca",
  null
  
)

export default component.exports